import { CallEffect, PutEffect, call, put } from 'redux-saga/effects';
import serviceLocator, { INDIVIDUAL_PORTAL_SVC } from '../../APIs/common/service-locator';
import {
    fetchCommunicationPreferencesFailure,
    fetchCommunicationPreferencesSuccess,
    setCommunicationPreferences
} from '../../actions/individualPortal/preferences/communicationPreferencesActionCreators';

// Types

import { CommunicationPreferences } from '../../components/ssap/SsapTypes';

export function* communicationPreferencesSaga():  Generator<
    CallEffect<unknown> | PutEffect<{type: string}>,
    void,
    any
> {
    try {
        const individualPortalService: ReturnType<(...args: any) => any> = yield call(
            serviceLocator,
            INDIVIDUAL_PORTAL_SVC
        );

        const communicationPreferences: { payload: CommunicationPreferences } = yield call([
            individualPortalService,
            individualPortalService.getCommunicationPreferences
        ]);

        if(communicationPreferences) {
            yield put(fetchCommunicationPreferencesSuccess());
            yield put(setCommunicationPreferences(communicationPreferences.payload));
        } else {
            yield put(fetchCommunicationPreferencesFailure());
        }
    } catch(e) {
        yield put(fetchCommunicationPreferencesFailure());
    }
}